import React, { useEffect, useRef } from "react"
import OutsideClickTrigger from "./OutsideClickTrigger"
import { parkingState } from "../../zustand/parkingState"
import config from "react-global-configuration"

const GenericModal = () => {
  const closeButtonRef = useRef(null)

  useEffect(() => {
    if (closeButtonRef) closeButtonRef.current.focus()
  }, [closeButtonRef])

  const handleClose = () => {
    const returnElement = document.getElementById(parkingState.getState().modalOpenerId)
    if (returnElement) returnElement.focus()

    parkingState.setState({ modalOpenerId: "" })
    parkingState.getState().genericModalClose(parkingState.getState().genericModalCallback)
  }

  const textKeys = config.get("textKeys.mainApp")

  return (
    <div className="overlay overlay--modal overlay--fixed is-active">
      <div className="modal">
        <OutsideClickTrigger onOutsideClick={handleClose}>
          <>
            <button
              aria-label={`${textKeys?.modalCloseAriaLabel}`}
              ref={closeButtonRef}
              className="button button--icon js--close-modal"
              onClick={handleClose}
            >
              <span className="icon">
                <svg className="svg-icon svg-icon--close-new">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                    &nbsp;
                  </use>
                </svg>
              </span>
            </button>
            <div className="modal__content">
              <div className="modal__content__inner">
                {/* <div className="modal__top" dangerouslySetInnerHTML={{ __html:  parkingState.getState().genericModalTop }}>
                </div> */}
                <div className="modal__middle rich-text" dangerouslySetInnerHTML={{ __html: parkingState.getState().genericModalBody }}></div>
                {/* <div className="modal__bottom" dangerouslySetInnerHTML={{ __html:  parkingState.getState().genericModalBottom }}>
                </div> */}
              </div>
            </div>
          </>
        </OutsideClickTrigger>
      </div>
    </div>
  )
}

export default GenericModal
